import { type ReactNode } from "react";
import classes from "./LabelBox.module.less";
import classNames from "classnames";

interface LabelBoxProps {
  className?: string;
  variant?: "active" | "inactive" | "darkGrey";
  children?: ReactNode;
}

const CLASSES = {
  active: classes.active,
  inactive: classes.inactive,
  darkGrey: classes.darkGrey,
};

/**
 * @deprecated use Chip instead
 */
const LabelBox = ({ className, children, variant = "active" }: LabelBoxProps) => {
  return <label className={classNames(classes.root, className, CLASSES[variant])}>{children}</label>;
};

export default LabelBox;
